<template>
  <div id="app" :class="{ 'dark': isdark, 'light': islight}">
    <router-view v-wechat-title='$route.meta.title'/>
  </div>
</template>

<script>
import store from '@/store/index'
export default {
  name: 'App',
  store,
  data(){
    return{
      getColor:null,
      isdark:true,
      islight: false,
      tonal:'',
      model:null,
    }
  },
  methods: {
    getColorFunc: function () {
      let data= window.AndroidForJsInterface?window.AndroidForJsInterface.getThemeColor(): '{"color":"#000","tonal":"dark"}'//data:'{color:'#f7f7f7',tonal:'light'}'   light代表浅色，dark代表深色
      this.getColor = JSON.parse(data)
      document.body.style.backgroundColor = this.getColor.color
      this.tonal =this.getColor.tonal
      if(this.tonal.indexOf("dark")>-1){
        this.isdark = true
        this.islight = false
      }
      if(this.tonal.indexOf("light")>-1){
        this.islight = true
        this.isdark = false
      }

    },
    getPhoneModel: function () {
      this.model =window.AndroidForJsInterface?JSON.parse(window.AndroidForJsInterface.getDeviceInfo()).model:'SKR-A0'
      this.$store.commit('phonemodel', this.model)
    }

  },
  mounted(){
      this.getColorFunc()
      this.getPhoneModel()

  }
}
</script>

<style>
html,body{
  height: 100%;
}
body{
background: transparent;
}
#app{
  height: 100%;
  
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding-top: 1px;
  min-height: 100%;
}
.aa{
  color:#fff;
}
</style>




// WEBPACK FOOTER //
// src/App.vue